<template>
  <div
    class="bg-ontick-green-100 text-ontick-carbon-900 dark:bg-ontick-steel-600 dark:bg-opacity-40 dark:text-gray-300"
  >
    <div
      class="mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:flex lg:items-center lg:justify-between lg:space-x-6 lg:py-24 lg:px-8"
    >
      <h2 class="text-3xl font-extrabold tracking-tight md:text-4xl">
        <span class="block">{{ data.title }}</span>
        <span class="text-ontick-green-600 block">{{ data.subtitle }}</span>
      </h2>
      <div class="mt-8 flex lg:mt-0 lg:flex-shrink-0">
        <div class="inline-flex rounded-md shadow">
          <a
            @click="scrollToPlans"
            class="bg-ontick-green-600 text-ontick-carbon-900 hover:bg-ontick-green-700 inline-flex cursor-pointer items-center justify-center rounded-md border border-transparent px-5 py-3 text-base font-medium"
          >
            {{ data.buttonText || "Ativar extensão" }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },
  methods: {
    scrollToPlans() {
      const plans = document.getElementById("plans");
      plans.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>
